import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

@Directive({
  selector: '[luiIntersectionObserver]',
  standalone: true,
  exportAs: 'luiIntersectionObserver',
})
export class IntersectionObserverDirective implements OnInit, OnDestroy {
  observer!: IntersectionObserver;

  isIntersecting!: boolean;

  @Input() get options(): IntersectionObserverInit {
    return this._options;
  }
  set options(value: IntersectionObserverInit) {
    this._options = value;
    if (this.observer) {
      this.observer.disconnect();
    }
    this.observer = this._create(value);
    this.observer.observe(this.elementRef.nativeElement);
  }
  private _options!: IntersectionObserverInit;

  @Output() intersectionChange = new EventEmitter<boolean>();

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    if (!this.options) {
      this.observer = this._create();
      this.observer.observe(this.elementRef.nativeElement);
    }
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }

  private _create(options?: IntersectionObserverInit): IntersectionObserver {
    return new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.isIntersecting = entry.isIntersecting;
        this.intersectionChange.emit(entry.isIntersecting);
      });
    }, options);
  }
}
